import React, { useState } from "react";
import Navbar from "../Website/Navbar";
import { PiDatabaseLight, PiHamburger } from "react-icons/pi";
import { useNavigate, useParams } from "react-router-dom";
import Introduction from "./DocPages/Introduction";
import ApiDoc from "./DocPages/ApiDoc";
import CrudOperations from "./DocPages/CrudOperations";
import OperationDocPage from "./DocPages/CrudOperations";
import { MdMenu } from "react-icons/md";
import IpNetwork from "./DocPages/IPNetowork";
import RESTIntro from "./DocPages/RestIntro";
import PythonSDK from "./DocPages/PythonSDK";
import PySdkPlaybox from "./DocPages/PySDKPlaybox";
import PyDeployments from "./DocPages/PyDeployments";
import DocsCodespace from "./DocPages/Codespace";

const MainDocumentation = () => {
    const { doc_page } = useParams()
    const navigate = useNavigate()
    const [openPhoneSide, setOpenPhoneSide] = useState(true)
    const [toggleSection, setToggleSection] = useState(null)

    const toggleOpenPhoneSide = () => {
        if (openPhoneSide) {
            setOpenPhoneSide(false)
        } else {
            setOpenPhoneSide(true)
        }
    }


    const toggleOpenSection = (section) => {
        toggleSection == section ? setToggleSection(null) : setToggleSection(section)
    }

    return (
        <div className="dev_docs_main_container">
            <Navbar title="Devs" />
            <div className="dev_docs_main_cont">
                <div className={`dev_docs_sidebar  ${openPhoneSide ? "" : "dev_docs_sidebar_closed"}`}>
                    {/* <p className="dev_docs_sidebar_title">
                        Erioon-DOCS
                    </p> */}
                    <div className="sidebar_doc_header">
                        <button className="sidebar_doc_header_btn" onClick={toggleOpenPhoneSide}><MdMenu /></button>
                    </div>
                    <p className="sidebar_doc_title">Get started</p>
                    <div className={`link_doc_cont ${doc_page === "introduction" ? "link_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/introduction")}>
                        <p>Introduction</p>
                    </div>
                    <div className={`link_doc_cont ${doc_page === "ip-network" ? "link_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/ip-network")}>
                        <p>Network & IPs</p>
                    </div>
                    <div className={`link_doc_cont ${doc_page === "api-key" ? "link_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/api-key")}>
                        <p>API Key</p>
                    </div>
                     <div className={`link_doc_cont ${doc_page === "py-sdk-db" ? "link_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/py-sdk-db")}>
                        <p>Database</p>
                    </div>  
                    {/* <div className={`link_doc_cont ${doc_page === "codespace" ? "link_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/codespace")}>
                        <p>Codespace</p>
                    </div>  */}
                    {/* <div className={`link_doc_cont ${doc_page === "py-sdk-playbox" ? "link_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/py-sdk-playbox")}>
                        <p>Playbox</p>
                    </div>
                    <div className={`link_doc_cont ${doc_page === "py-sdk-deployments" ? "link_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/py-sdk-deployments")}>
                        <p>Deployments</p>
                    </div> */}
                    {/* <p className="sidebar_doc_title">REST</p> */}
                    {/* <div className={`link_doc_cont ${doc_page === "rest-api" ? "link_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/rest-api")}>
                        <p>REST-API</p>
                    </div>
                    <div className={`sublink_cont_open`}>

                        <div className={`sublink_doc_cont ${doc_page === "insert_one" ? "sublink_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/insert_one")}>
                            <p>insert_one</p>
                        </div>

                        <div className={`sublink_doc_cont ${doc_page === "insert_many" ? "sublink_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/insert_many")}>
                            <p>insert_many</p>
                        </div>

                        <div className={`sublink_doc_cont ${doc_page === "get_all" ? "sublink_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/get_all")}>
                            <p>get_all</p>
                        </div>

                        <div className={`sublink_doc_cont ${doc_page === "get_specific" ? "sublink_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/get_specific")}>
                            <p>get_specific</p>
                        </div>

                        <div className={`sublink_doc_cont ${doc_page === "delete_one" ? "sublink_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/delete_one")}>
                            <p>delete_one</p>
                        </div>

                        <div className={`sublink_doc_cont ${doc_page === "delete_many" ? "sublink_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/delete_many")}>
                            <p>delete_many</p>
                        </div>

                        <div className={`sublink_doc_cont ${doc_page === "update_query" ? "sublink_doc_cont_selected" : ""}`} onClick={() => navigate("/dev-docs/update_query")}>
                            <p>update_query</p>
                        </div>
                    </div> */}
                </div>
                <div className="dev_docs_body">
                    {doc_page === "introduction" ? (
                        <Introduction />
                    ) : doc_page === "ip-network" ? (
                        <IpNetwork />
                    ) : doc_page === "api-key" ? (
                        <ApiDoc />
                    ) : doc_page === "rest-api" ? (
                        <RESTIntro />
                    ) : doc_page === "py-sdk-db" ? (
                        <PythonSDK />
                    ) : doc_page === "py-sdk-playbox" ? (
                        <PySdkPlaybox />
                    ): doc_page === "py-sdk-deployments" ? (
                        <PyDeployments />
                    ): doc_page === "codespace" ? (
                        <DocsCodespace />
                    ): (
                        <OperationDocPage />
                    )}

                </div>
            </div>
        </div>
    )
}

export default MainDocumentation